import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';

const ManageChannelsText = styled.div<React.CSSProperties>`
  font-family: ${Fonts['regular']};
  font-size: ${34 * Screen.widthRatio}px;
  color: ${Colors['light']};
  line-height: ${60 * Screen.widthRatio}px;
`;

export default ManageChannelsText;
